export enum SearchCriteriaQuerySentimentsEnum {
    positive = 'POSITIVE',
    neutral = 'NEUTRAL',
    negative = 'NEGATIVE',
    notAvailable = 'NOT_AVAILABLE'
}

export function mapSentimentValueToEnum(value: string): SearchCriteriaQuerySentimentsEnum {
    const numberValue = parseFloat(value);

    if (isNaN(numberValue)) {
        return SearchCriteriaQuerySentimentsEnum.notAvailable;
    }

    if (numberValue <= -0.3) {
        return SearchCriteriaQuerySentimentsEnum.negative;
    } else if (numberValue >= 0.3) {
        return SearchCriteriaQuerySentimentsEnum.positive;
    } else {
        return SearchCriteriaQuerySentimentsEnum.neutral;
    }
}
